export const AIFC_ONBOARDING_STATE_KEYS = {
	hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
	isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
	hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
	hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
	isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
	hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
	hasDismissedGettingStartedTour: 'aifc-onboarding:hasDismissedGettingStartedTour',
	hasSeenDeeplinkReturnSpotlight: 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight',
	hasSeenTwcAifcOnboarding: 'aifc-onboarding:hasSeenTwcAifcOnboarding',
} as const;

export const AIFCOnboardingKeys: readonly (
	| 'aifc-onboarding:hasSeenAIFCSpotlight'
	| 'aifc-onboarding:isAIFCSpotlightActive'
	| 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight'
	| 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight'
	| 'aifc-onboarding:isAIFCChatSpotlightActive'
	| 'aifc-onboarding:hasSeenAIFCChatSpotlight'
	| 'aifc-onboarding:hasDismissedGettingStartedTour'
	| 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight'
	| 'aifc-onboarding:hasSeenTwcAifcOnboarding'
)[] = Object.values(AIFC_ONBOARDING_STATE_KEYS);
